module.exports = __webpack_public_path__ + "img/mn.779cc0c6.svg";